class BundlePicker extends HTMLElement {
  connectedCallback() {
    const targetFormId = this.dataset.targetFormId;
    this.targetForm = targetFormId ? document.getElementById(targetFormId) : null;

    if (!this.targetForm) {
      console.warn(
        `bundle-picker: could not find add-to-cart form "${targetFormId}" to attach bundle properties to.`
      );
      return;
    }

    this.variantIdsInput = this.#getOrCreateHiddenInput('properties[_bundle_variant_ids_list]');
    this.baseProductIdInput = this.#getOrCreateHiddenInput('properties[_bundle_base_product_id]');
    this.baseProductIdInput.value = this.dataset.baseProductId || '';

    this.radios = this.querySelectorAll('.bundle-picker__variant-radio');
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.updateVariantIds());
    });
    this.updateVariantIds();
  }

  #getOrCreateHiddenInput(name) {
    let input = this.targetForm.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      this.targetForm.appendChild(input);
    }
    return input;
  }

  updateVariantIds() {
    if (!this.variantIdsInput) return;

    const variantIds = [];
    const items = this.querySelectorAll('.bundle-picker__item');

    items.forEach((item) => {
      const variantsScript = item.querySelector('script.bundle-picker__variants');
      const dataScript = item.querySelector('script.bundle-picker__product-data');

      if (variantsScript) {
        const variants = JSON.parse(variantsScript.textContent);
        const fieldsets = item.querySelectorAll('.bundle-picker__option');
        const selectedValues = Array.from(fieldsets).map((fieldset) => {
          const checked = fieldset.querySelector('.bundle-picker__variant-radio:checked');
          return checked ? checked.value : null;
        });

        const matchingVariant = variants.find((variant) =>
          variant.options.every((option, index) => option === selectedValues[index])
        );

        if (matchingVariant) {
          variantIds.push(`gid://shopify/ProductVariant/${matchingVariant.id}`);
        }
      } else if (dataScript) {
        const data = JSON.parse(dataScript.textContent);
        if (data.selectedVariantId) {
          variantIds.push(`gid://shopify/ProductVariant/${data.selectedVariantId}`);
        }
      }
    });

    this.variantIdsInput.value = variantIds.join(',');
  }
}

customElements.define('bundle-picker', BundlePicker);
